import type { Params } from 'react-router-dom'

import moment from 'moment'

import type { ViewType } from 'modules/shift_management/store/internal/models/View'

export const periodFromParams = (
  params: Readonly<Params<string>>,
  currentViewType: ViewType
): moment.Moment => {
  const { year, month, day } = params

  let date = moment([Number(year), Number(month) - 1, Number(day)])

  // In order to properly scope down the dates, we have to consider the following:

  // If within current month:
  // Redirecting from monthly or 4 weeks to weekly or daily: use moment() to go to this week or today
  // Redirecting from weekly work areas to weekly employees or vice versa, keep the params dates so we see same week

  // If within current week:
  // Redirecting from weekly to daily, use moment() to go to today's date

  // Any other scenarios:
  // Use the params dates to build the view, going to the first day of the period

  const isCurrentCalendarMonth = date.isSame(new Date(), 'month')
  const isCurrentCalendarWeek = date.isSame(new Date(), 'week')
  const isWeekly = currentViewType === 'weekly'
  const isDaily = currentViewType === 'daily'
  const isNotWeeklyNorDaily = !isWeekly && !isDaily

  if ((isCurrentCalendarMonth && isNotWeeklyNorDaily) || (isCurrentCalendarWeek && isWeekly)) {
    date = moment()
  }

  return date.isValid() ? date : moment()
}
